export class IsOrtagiFilterResultModel {
  id: any;
  kisaAdi: any;
  adi: any;
}
